import { httpClient } from '../http/httpClient'

export type SendProposalRequest = {
  operacoes_credito: {
    sucesso: boolean
    mensagem_erro: string
    prazo: number
    metodo: string
    codigo_tabela_financiamento: string
    descricao_tabela_financiamento: string
    codigo_produto: string
    descricao_produto: string
    primeiro_vencimento: string
    ultimo_vencimento: string
    despesas: {
      valor_padrao_mutavel: boolean
      codigo: number
      grupo: string
      financiada: boolean
      tipo: number
      inclusa: boolean
      numero_item: number
      obrigatoria: boolean
      valor_calculado: number
      valor_maximo: number
      valor_minimo: number
    }[]
    taxa_apropriacao_anual: number
    taxa_apropriacao_mensal: number
    taxa_cet_anual: number
    taxa_cet_mensal: number
    taxa_referencia_anual: number
    taxa_referencia_mensal: number
    valor_bruto: number
    valor_cliente: number
    valor_financiado: number
    valor_solicitado: number
    valor_iof: number
    valor_liquido: number
    valor_parcela: number
    refinanciamentos: any[]
  }
  customerId: string
}

export type SendProposalResponse = {}

export async function sendProposal(
  id: string,
  payload: SendProposalRequest,
): Promise<SendProposalResponse> {
  const { data } = await httpClient
    .put<SendProposalResponse>(`/pan/${id}/send`, payload)
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
